import { render, staticRenderFns } from "./CashFlowStatement.vue?vue&type=template&id=52092490&scoped=true"
import script from "./CashFlowStatement.vue?vue&type=script&lang=js"
export * from "./CashFlowStatement.vue?vue&type=script&lang=js"
import style0 from "./CashFlowStatement.vue?vue&type=style&index=0&id=52092490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52092490",
  null
  
)

export default component.exports